import styled from 'styled-components'

export const StyledCountingText = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
`
